// Smart Device Insurance Policy Constants and Data
import cancelPolicy from "../../assets/images/cancelPolicy.svg";
import refreshIcon from "../../assets/images/refresh-dark.svg";

// Smart Device-specific action type constants
export const CANCEL_POLICY_SMART_DEVICE = "CANCEL_POLICY_SMART_DEVICE";

// Smart Device Policy Overview Data
export const smartDevicePolicyOverview = {
  policyInfo: {
    policy_label: "Your Smart Device Policy",
    policy_label_ar: "وثيقة تأمين الجهاز الذكي",
    status: "Active",
    status_ar: "نشيط",
    planName: "Smart Device Insurance Policy",
    planName_ar: "وثيقة تأمين الجهاز الذكي",
    policyNumber: "",
    date: {
      startDate: "",
      endDate: "",
    },
    btn: {
      icon: refreshIcon,
      btn_lable_en: "Renew Policy",
      btn_lable_ar: "تجديد الوثيقة",
    },
  },
  cards: [
    {
      icon: "",
      value: "24/7 Support",
      value_ar: "دعم على مدار الساعة",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Device Coverage",
      value_ar: "تغطية الجهاز",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Claim Support",
      value_ar: "دعم المطالبات",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    }
  ]
};

// Smart Device Policy Manage Actions (only Cancel Policy)
export const manageSmartDevicePolicy = {
  cards: [
    {
      icon: cancelPolicy,
      value: "Cancel Policy",
      value_ar: "إلغاء السياسة",
      type: CANCEL_POLICY_SMART_DEVICE
    }
  ]
};

// Smart Device Benefits
export const smartDeviceBenefits = [
  "Accidental Damage Protection",
  "Theft and Loss Coverage",
  "Liquid Damage Protection",
  "Screen Crack Repair",
  "24/7 Claims Support"
];

// Function to filter cards for smart device (only cancel policy)
export const getFilteredSmartDeviceCards = (policyDetails) => {
  return manageSmartDevicePolicy.cards;
};